import { NewRechargeStep } from '../../types';
export const STEP_ORDER_MAP = {
    [NewRechargeStep.COMPETENCE]: 1,
    [NewRechargeStep.GLOBAL_SETTINGS]: 2,
    [NewRechargeStep.BENEFICIARIES_VALUES]: 3,
    [NewRechargeStep.DELIVERY_ADDRESS]: 4,
    [NewRechargeStep.PAYMENT]: 5,
    [NewRechargeStep.SUMMARY]: 6,
};
export const STEP_CONFIGS = [
    {
        number: 1,
        id: NewRechargeStep.COMPETENCE,
        translationKey: 'recharge.step.competence',
    },
    {
        number: 2,
        id: NewRechargeStep.GLOBAL_SETTINGS,
        translationKey: 'recharge.step.global-settings',
    },
    {
        number: 3,
        id: NewRechargeStep.BENEFICIARIES_VALUES,
        translationKey: 'recharge.step.beneficiaries-values',
    },
    {
        number: 4,
        id: NewRechargeStep.DELIVERY_ADDRESS,
        translationKey: 'recharge.step.delivery-address',
    },
    {
        number: 5,
        id: NewRechargeStep.PAYMENT,
        translationKey: 'recharge.step.payment',
    },
];
export const MAX_COMPLETABLE_STEP_ORDER = STEP_ORDER_MAP[NewRechargeStep.DELIVERY_ADDRESS];
